import React, { Component } from "react";
import { connect } from "react-redux";
import { ProjectListHeader } from "../../../components";
import { back, push } from "../../../actions/nav-actions";
import { fetchActualResults, fetchEvaluatingResults } from "../../../api";

const filterBy = (category) => (i) => i.result.category === category;
const mapIndicator = (x, index) => ({ ...x, originalIndex: index });

class ActualMap extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {},
    evaluating_results: {},
  };
  constructor(props) {
    super(props);
    this.getParams = this.getParams.bind(this);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchActualResults(
        this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => {
          return fetchEvaluatingResults(
            this.props.user.token,
            params.organization,
            params.code
          ).then((evaluating_results) => ({ data, evaluating_results }));
        })
        .then(({ data, evaluating_results }) =>
          this.setState({ is_loading: false, data, evaluating_results })
        )
        .catch((err) => this.setState({ is_loading: false, error: err }));
    });
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>;
    if (!this.state.data.results || this.state.is_loading)
      return <span>Loading data...</span>;

    return (
      <React.Fragment>
        <div>
          {this.state.data.options.goals.map((goal, goal_index) => {
            let evaluating_indicators = this.state.evaluating_results.options.goals.filter(
              (g) => goal._id.toString() === g._id.toString()
            )[0];
            if (!evaluating_indicators) {
              evaluating_indicators = {
                indicators: [],
              };
            }

            const actualOutputIndicators = goal.indicators
              .map(mapIndicator)
              .filter(filterBy("output"));

            const actualOutcomeIndicators = goal.indicators
              .map(mapIndicator)
              .filter(filterBy("outcomes"));

            const actualImpactIndicators = goal.indicators
              .map(mapIndicator)
              .filter(filterBy("impact"));

            return (
              <div>
                <ProjectListHeader
                  style={{ marginTop: 32 }}
                  title={"Goal " + (goal_index + 1) + ": " + goal.name}
                />
                <ProjectListHeader
                  style={{ marginTop: 32, marginBottom: 32 }}
                  title="ACTIVITIES"
                  dark
                />
                <div className="col-12 img-thumbnail">
                  {goal.activities.map((activity, activity_index) => {
                    return (
                      <div>
                        <ProjectListHeader
                          style={{ marginTop: 32, marginBottom: 32 }}
                          title={
                            "Activity " +
                            (activity_index + 1) +
                            ": " +
                            activity.activity.name
                          }
                          dark
                        />
                        <p>{activity.relation}</p>
                      </div>
                    );
                  })}
                </div>
                <ProjectListHeader
                  style={{ marginTop: 32, marginBottom: 32 }}
                  title="INDICATORS"
                  dark
                />
                <div className="row">
                  <div className="col-4">
                    <span className="text-center btn-block">OUTPUT</span>
                    {actualOutputIndicators.map((indicator) => {
                      return (
                        <div>
                          <span className="text-primary">
                            {
                              evaluating_indicators.indicators[
                                indicator.originalIndex
                              ].indicator.measure
                            }
                          </span>
                          <br /> <br />
                          <span className="text-info">ACTUAL RESULTS</span>
                          <br />
                          <p>
                            {
                              evaluating_indicators.indicators[
                                indicator.originalIndex
                              ].result.input
                            }
                          </p>
                        </div>
                      );
                    })}
                    {actualOutputIndicators.length > 0 && (
                      <span className="text-info">EVALUATING RESULTS</span>
                    )}
                    <br />
                    {actualOutputIndicators.map((indicator) => {
                      return (
                        <div>
                          <p>{indicator.result.input}</p>
                        </div>
                      );
                    })}
                  </div>

                  <div className="col-4">
                    <span className="text-center btn-block">OUTCOME</span>
                    {actualOutcomeIndicators.map((indicator) => {
                      return (
                        <div>
                          <span className="text-primary">
                            {
                              evaluating_indicators.indicators[
                                indicator.originalIndex
                              ].indicator.measure
                            }
                          </span>
                          <br /> <br />
                          <span className="text-info">ACTUAL RESULTS</span>
                          <br />
                          <p>
                            {
                              evaluating_indicators.indicators[
                                indicator.originalIndex
                              ].result.input
                            }
                          </p>
                        </div>
                      );
                    })}
                    {actualOutcomeIndicators.length > 0 && (
                      <span className="text-info">EVALUATING RESULTS</span>
                    )}
                    <br />
                    {actualOutcomeIndicators.map((indicator) => {
                      return (
                        <div>
                          <p>{indicator.result.input}</p>
                        </div>
                      );
                    })}
                  </div>

                  <div className="col-4">
                    <span className="text-center btn-block">IMPACT</span>
                    {actualImpactIndicators.map((indicator) => {
                      return (
                        <div>
                          <span className="text-primary">
                            {
                              evaluating_indicators.indicators[
                                indicator.originalIndex
                              ].indicator.measure
                            }
                          </span>
                          <br /> <br />
                          <span className="text-info">ACTUAL RESULTS</span>
                          <br />
                          <p>
                            {
                              evaluating_indicators.indicators[
                                indicator.originalIndex
                              ].result.input
                            }
                          </p>
                        </div>
                      );
                    })}
                    {actualImpactIndicators.length > 0 && (
                      <span className="text-info">EVALUATING RESULTS</span>
                    )}
                    <br />
                    {actualImpactIndicators.map((indicator) => {
                      return (
                        <div>
                          <p>{indicator.result.input}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {goal.subgoals.map((subgoal, subgoal_index) => {
                  let all_goals = this.state.evaluating_results.options.goals.reduce(
                    (acc, goal) => [...acc, { ...goal }, ...goal.subgoals],
                    []
                  );
                  let subgoal_indicators = all_goals.filter(
                    (g) => subgoal._id.toString() === g._id.toString()
                  )[0];
                  if (!subgoal_indicators) {
                    subgoal_indicators = {
                      indicators: [],
                    };
                  }

                  const actualSubgoalOutputIndicators = subgoal.indicators
                    .map(mapIndicator)
                    .filter(filterBy("output"));

                  const actualSubgoalOutcomeIndicators = subgoal.indicators
                    .map(mapIndicator)
                    .filter(filterBy("outcomes"));

                  const actualSubgoalImpactIndicators = subgoal.indicators
                    .map(mapIndicator)
                    .filter(filterBy("impact"));

                  return (
                    <div>
                      <ProjectListHeader
                        style={{ marginTop: 32 }}
                        title={
                          "Subgoal " +
                          (goal_index + 1) +
                          "." +
                          (subgoal_index + 1) +
                          ": " +
                          subgoal.name
                        }
                      />
                      <ProjectListHeader
                        style={{ marginTop: 32, marginBottom: 32 }}
                        title="ACTIVITIES"
                        dark
                      />
                      <div className="col-12 img-thumbnail">
                        {subgoal.activities.map((subActivity, activity_index) => {
                          return (
                            <div>
                              <ProjectListHeader
                                style={{ marginTop: 32, marginBottom: 32 }}
                                title={
                                  "Activity " +
                                  (activity_index + 1) +
                                  ": " +
                                  subActivity.activity.name
                                }
                                dark
                              />
                              <p>{subActivity.relation}</p>
                            </div>
                          );
                        })}
                      </div>
                      <ProjectListHeader
                        title="INDICATORS"
                        style={{ marginTop: 32, marginBottom: 32 }}
                        dark
                      />
                      <div className="row">
                        <div className="col-4">
                          <span className="text-center btn-block">OUTPUT</span>
                          {actualSubgoalOutputIndicators.map((indicator) => {
                            return (
                              <div>
                                <span className="text-primary">
                                  {
                                    subgoal_indicators.indicators[
                                      indicator.originalIndex
                                    ].indicator.measure
                                  }
                                </span>
                                <br /> <br />
                                <span className="text-info">
                                  ACTUAL RESULTS
                                </span>
                                <br />
                                <p>
                                  {
                                    subgoal_indicators.indicators[
                                      indicator.originalIndex
                                    ].result.input
                                  }
                                </p>
                              </div>
                            );
                          })}
                          {actualSubgoalOutputIndicators.length > 0 && (
                            <span className="text-info">EVALUATING RESULTS</span>
                          )}
                          <br />
                          {actualSubgoalOutputIndicators.map((indicator) => {
                            return (
                              <div>
                                <p>{indicator.result.input}</p>
                              </div>
                            );
                          })}
                        </div>

                        <div className="col-4">
                          <span className="text-center btn-block">OUTCOME</span>
                          {actualSubgoalOutcomeIndicators.map((indicator) => {
                            return (
                              <div>
                                <span className="text-primary">
                                  {
                                    subgoal_indicators.indicators[
                                      indicator.originalIndex
                                    ].indicator.measure
                                  }
                                </span>
                                <br /> <br />
                                <span className="text-info">
                                  ACTUAL RESULTS
                                </span>
                                <br />
                                <p>
                                  {
                                    subgoal_indicators.indicators[
                                      indicator.originalIndex
                                    ].result.input
                                  }
                                </p>
                              </div>
                            );
                          })}
                          {actualSubgoalOutcomeIndicators.length > 0 && (
                            <span className="text-info">EVALUATING RESULTS</span>
                          )}
                          <br />
                          {actualSubgoalOutcomeIndicators.map((indicator) => {
                            return (
                              <div>
                                <p>{indicator.result.input}</p>
                              </div>
                            );
                          })}
                        </div>

                        <div className="col-4">
                          <span className="text-center btn-block">IMPACT</span>
                          {actualImpactIndicators.map((indicator) => {
                            return (
                              <div>
                                <span className="text-primary">
                                  {
                                    subgoal_indicators.indicators[
                                      indicator.originalIndex
                                    ].indicator.measure
                                  }
                                </span>
                                <br /> <br />
                                <span className="text-info">
                                  ACTUAL RESULTS
                                </span>
                                <br />
                                <p>
                                  {
                                    subgoal_indicators.indicators[
                                      indicator.originalIndex
                                    ].result.input
                                  }
                                </p>
                              </div>
                            );
                          })}
                          {actualImpactIndicators.length > 0 && (
                            <span className="text-info">
                              EVALUATING RESULTS
                            </span>
                          )}
                          <br />
                          {actualImpactIndicators.map((indicator) => {
                            return (
                              <div>
                                <p>{indicator.result.input}</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.authReducer.user });

const mapDispatchToProps = (dispatch) => ({
  back() {
    dispatch(back());
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ActualMap);



// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/ActualMapFormularies.js